import React from "react";
import { connect } from "react-redux";
import { callService } from "../tools";
import {servicios} from "../properties";

const urlDetalle = servicios.detalle;
const urlBASE = servicios.directorio.endPoint;

const mapState = (state) => {
	return {
	    uid_: state.global.uid,
		uid: state.login.cveCliente,
	};
};
      

export const nombreProductoGM = (item) => {
	let sNombre = "";
	if (item.generales.cveClasificacionSeguro == "06" || item.generales.cveClasificacionSeguro == "05") {
		sNombre = sNombre + "GRUPO: ";
	}
	if ((item.generales.cveProdTecnico == "G0334GMMII" || item.generales.cveProdTecnico == "G0334GMMIN") && (item.generales.cveProdComercial == "00004" || item.generales.cveProdComercial == "00005" || item.generales.cveProdComercial == "00006")) {	
		sNombre = sNombre + " " + item.generales.productoComercial + " ";
	}
	sNombre = sNombre + " " + item.generales.planComercial + " " + item.generales.circuloMedico;
	try {
		//let cliente;
		// item.asegurados.map((m) => {
		// 	if(m.banderaTitular === 1) {
		// 		cliente = m.certificado;
		// 	}
		// });
		
		var numcliente=$( ".blue-bold-text" ).text();
       var uid=numcliente.substring(0,10);
       console.log("uid------"+uid);

		console.log("Cve Cliente: " + localStorage.getItem("cveCliente"));
		let cliente = uid;
		if(localStorage.getItem("detallePoliza") === null || !(localStorage.getItem("detallePoliza").length > 0)) {
			let params = "?clienteUnico=" + uid;
			let urIdenPoliza = urlDetalle + params;
			console.log("SIN_CF_identificarPoliza: " + urIdenPoliza);

			try {
				$.ajax({
					method: "GET",
					url: urIdenPoliza,
					async: false,
					dataType: "json",
					success: (data) => {
						localStorage.setItem("detallePoliza", JSON.stringify(data));
					},
					error: (error) => {
						localStorage.setItem("detallePoliza","");
						console.log(error);
					}
				});
			} catch(e) {
			    console.log("Error en el servicio: " + urlDetalle);
				console.log(e);
			}
			try {
				$.ajax({
					method: "GET",
					url: urlBASE+"/directorios/planes-subplanes",
					dataType: "json",
					async: false,
					success: (data) => {
						localStorage.setItem("planesSubplanesGNP", JSON.stringify(data));
					},
					error: (error) => {
						localStorage.setItem("planesSubplanesGNP", "");
						console.log(error);
					}
				});
			} catch (e) {
				console.log(e);
			}
		}
		let str = localStorage.getItem("planesCliente") ? localStorage.getItem("planesCliente") : "";
		let detalle = localStorage.getItem("detallePoliza") ? JSON.parse(localStorage.getItem("detallePoliza")) : JSON.parse("[polizas:{}]");
		let cvePlan = 0;
		let nombrePlan = "";
		//Si viene con planComercial
		if(item.generales.planComercial) {
		
			detalle.polizas.map((p) => {
				if(p.planComercial === item.generales.planComercial) {
					cvePlan = p.cvePlanComercial;
				}
			});

			if (str === null || str === "" ) {
				//Agregar plan
				str = "|{\"planComercial\": \"" +  item.generales.planComercial + "\", \"numPoliza\": \"" + item.generales.numPoliza + "\", \"cvePlan\": " + cvePlan + "}";
			} else {
				//Validar que no este repetido
				let planesCliente = str.replace("|", "");
				let planesClienteArray = planesCliente.split("|");
				let aux = "";
				for(let a = 0; a < planesClienteArray.length; a++) {
					aux = aux + planesClienteArray[a] + ",";
				}
				aux = aux.substring(0, str.length - 1);
				let planesC = JSON.parse("{\"planesClientes\": [" + aux +  "]}");
				
				let enLista = false;
				for(let i = 0; i < planesC.planesClientes.length; i++){
					if(item.generales.planComercial === planesC.planesClientes[i].planComercial) {
						if(item.generales.numPoliza === planesC.planesClientes[i].numPoliza){
							enLista = true; //Ya se habia agregado
							break;
						}
					}
				}
				if(!enLista){
					str = str + "|" + "{\"planComercial\": \"" +  item.generales.planComercial + "\", \"numPoliza\": \"" + item.generales.numPoliza + "\", \"cvePlan\": " + cvePlan + "}";
				}
			}
		}

		localStorage.setItem("planesCliente", str);
	} catch (e) {
		console.log(e);
	}
	if (item.generales.cveProdTecnico == "G0334SEGMA" && item.generales.cveProdComercial == "00003" ) {	
		sNombre = item.generales.planComercial + " ";
	}
	return sNombre;
};

export const getNumPoliza = (item) => {
	let displayPoliza = item.generales.numPoliza;
	if(isSantanderAndReferencia(item)){
		if(item.generales.referenciaOriginal){
			displayPoliza = item.generales.referenciaOriginal;
		}
		if(item.generales.referencia1){
			displayPoliza = item.generales.referencia1;
		}
	}
	return displayPoliza;
};

export const isSantander = (item) => {
	return item && item.generales && item.generales.cveProdTecnico == "A2400AUTG" && 
	(item.generales.cveProdComercial == "00001" || 
	item.generales.cveProdComercial == "00002");
};

export const isSantanderAndReferencia = (item) => {
	return item && item.generales && item.generales.cveProdTecnico == "A2400AUTG" && 
	(item.generales.cveProdComercial == "00001" || 
	item.generales.cveProdComercial == "00002") && 
	item.generales.referencia1;
};


// WEBPACK FOOTER //
// ./src/common/logica.js